import { render, staticRenderFns } from "./WSplash.vue?vue&type=template&id=54e6a120&"
import script from "./WSplash.vue?vue&type=script&lang=ts&"
export * from "./WSplash.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports